import { NgModule } from '@angular/core';
import { GtmGgCategoryPageEventBuilder } from './gtm-gg-category-page-event.builder';

@NgModule({})
export class GtmGgCategoryPageEventModule {
  constructor(_gtmGgCategoryPageEventBuilder: GtmGgCategoryPageEventBuilder) {}
}
